module.exports = __webpack_public_path__ + "fb44249b3cab27dae6f58b77568624c3.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/lankenau04.jpg
// module id = 519
// module chunks = 0